import { DataTable } from "../../../../shared/components/data-table/DataTable";
import ActiveBadge from "../../../../shared/components/badge/ActiveBadge";

const RoleUsersTable = ({ data }) => {
  const columns = [
    {
      accessorKey: "username",
      header: "Nombre de usuario",
    },
    {
      accessorKey: "fullname",
      header: "Nombre completo",
    },
    {
      accessorKey: "email",
      header: "Correo electrónico",
    },
    {
      accessorKey: "enabled",
      header: "Estado",
      cell: ({ row }) => <ActiveBadge booleanValue={row.getValue("enabled")} />,
    },
  ];

  return <DataTable data={data} columns={columns} />;
};

export default RoleUsersTable;
